import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { AiFillCaretLeft, AiFillCaretRight, AiFillCaretDown } from "react-icons/ai";
import PercentageBar from '../PercentageBar';
import "../../Styles/HomeMap.css";
import { SideController } from "./SideController";
import ReligionPageSide from "../ReligionPageSide";
import mapboxgl from 'mapbox-gl';
import { world_religion } from "./WorldReligion";
import { Centroid } from "../../Centroid";
import {religious_data} from "../../Religious_data";
import Collapsible from "react-collapsible";
import tibetanSub from '../../Assets/tibetanSub.png';
import theravadaSub from '../../Assets/theravadaSub.png';
import otherSub from '../../Assets/otherSub.png';
import eastSub from '../../Assets/eastSub.png';
import sunniSub from '../../Assets/sunniSub.png';
import mahayanaSub from '../../Assets/mahayanaSub.png';
import 'mapbox-gl/dist/mapbox-gl.css'; 
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';


mapboxgl.accessToken = 'pk.eyJ1IjoiZWRtYW4iLCJhIjoiY2syNWs1ajk3MGM2NjNua3gxYTNhdWpkOSJ9.ngu-SlVjhLdLBPyDFFsIBw';

const BuddhismPage = () => {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(-70.9);
    const [lat, setLat] = useState(42.35);
    const [zoom, setZoom] = useState(1);
    const [firstReligion, setFirstReligion] = useState("...");
    const [secondReligion, setSecondReligion] = useState("...");
    const [province, setProvince] = useState("...");
    const [country, setCountry] = useState("...");
    const [numerical, setNumerical] = useState(null);
    const [numeric_1, setNumeric_1] = useState(null);
    const [year, setYear] = useState("...");
    const [dataSource, setDataSource] = useState("...");
    const [dataURL, setDataURL] = useState("...");
    const [sideFeatures, setSideFeatures] = useState([]);
    const popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
      anchor:"top-left"
    });
    const [markers, setMarkers] = useState({});
 
    var c = "";

    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [lng, lat],
            zoom: zoom,
            maxZoom: 5,
            renderWorldCopies: false,
        });

        map.current.addControl(new mapboxgl.NavigationControl());
        map.current.addControl(
          new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl,
          marker:false,
          types:"country,region",
          collapsed: true,
          language:"en"
          })
          );
        map.current.doubleClickZoom.disable();
    }, []);

    useEffect(() => {
        map.current.on('load', () => {
            map.current.addSource('world_religion', {
                'type': 'vector',
                'url': 'mapbox://edman.BRI_Religion_JSON2'
            });
            map.current.addLayer(world_religion, 'state-label');
            map.current.addLayer({
                'id': 'state-fills',
                'type': 'fill',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_JSON2',
                'layout': {},
                'paint': {'fill-color': 'transparent','fill-outline-color':'black','fill-opacity': ['case',['boolean', ['feature-state', 'click'], false],1,0]}
                }
            );
            map.current.addLayer({
                'id': 'hover-fills',
                'type': 'line',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_JSON2',
                'layout': {},
                'paint': {'line-width': 1}
                },'state-label'
            );
            map.current.setLayoutProperty("settlement-subdivision-label", 'visibility', 'none');
        });

        map.current.on('mousemove', 'state-fills', (e) => {
            map.current.setFilter("hover-fills", [
                "any",
                ["==", "ProvName", e.features[0].properties.ProvName],
              ]);
            setFirstReligion(e.features[0].properties.HighRelig);
            setSecondReligion(e.features[0].properties.SecRelig);
            setProvince(e.features[0].properties.ProvName);
            setCountry(e.features[0].properties.Country);
            setNumerical(e.features[0].properties.Numerical);
            setNumeric_1(e.features[0].properties.Nummeric_1);
            setYear(e.features[0].properties.Year);
            setDataSource(e.features[0].properties.DataSource);
            setDataURL(e.features[0].properties.DataURL);
            
            popup.setLngLat([e.lngLat.lng,e.lngLat.lat].slice()).setHTML("").addTo(map.current);

            var popupProvName = document.createElement('div')
            popupProvName.className = 'popupProvName'
            popupProvName.innerHTML = e.features[0].properties.ProvName
            var popupCountry = document.createElement('div')
            popupCountry.className = 'popupCountry'
            popupCountry.innerHTML = e.features[0].properties.Country
            var popupNumerical = document.createElement('div')
            popupNumerical.className = 'popupNumerical'
            popupNumerical.innerHTML = e.features[0].properties.Numerical+"%"
            var popupHighRelig = document.createElement('div')
            popupHighRelig.className = 'popupHighRelig'
            popupHighRelig.innerHTML = e.features[0].properties.HighRelig
            var popupNumeric_1 = document.createElement('div')
            popupNumeric_1.className = 'popupNumeric_1'
            popupNumeric_1.innerHTML = e.features[0].properties.Nummeric_1+"%"
            var popupSecRelig = document.createElement('div')
            popupSecRelig.className = 'popupSecRelig'
            popupSecRelig.innerHTML = e.features[0].properties.SecRelig
            var popupYear = document.createElement('div')
            popupYear.className = 'popupYear'
            popupYear.innerHTML = "Year of Data: " + e.features[0].properties.Year
            // var popupDataSource = document.createElement('div')
            // popupDataSource.className = 'popupDataSource'
            // popupDataSource.innerHTML = "Data Source:" + e.features[0].properties.DataSource
            // var popupButton = document.createElement('div')
            // popupButton.className = 'popupButton '
            // popupButton.id = e.features[0].properties.Country
            // popupButton.title = e.features[0].properties.ProvName
            // popupButton.onclick = function(){save(this.id, this.title)}


            document.getElementsByClassName("mapboxgl-popup-content")[0].append(popupProvName,popupCountry,popupNumerical,popupHighRelig,popupNumeric_1,popupSecRelig,popupYear)
            
        });

        map.current.on('click', 'state-fills', (e) => {
            map.current.setFilter("hover-fills", [
                "any",
                ["==", "ProvName", e.features[0].properties.ProvName],
              ]);
            setFirstReligion(e.features[0].properties.HighRelig);
            setSecondReligion(e.features[0].properties.SecRelig);
            setProvince(e.features[0].properties.ProvName);
            setCountry(e.features[0].properties.Country);
            setNumerical(e.features[0].properties.Numerical);
            setNumeric_1(e.features[0].properties.Nummeric_1);
            setYear(e.features[0].properties.Year);
            setDataSource(e.features[0].properties.DataSource);
            setDataURL(e.features[0].properties.DataURL);
            setSideMode(e.features[0].properties.Country.toString());
            document.getElementById(e.features[0].properties.ProvName).scrollIntoView();
            
        });
        map.current.on('dblclick', 'state-fills', (e) => {
          save(e.features[0].properties.Country ,e.features[0].properties.ProvName);
        });

        map.current.on('mouseleave', 'state-fills', () => {
            map.current.setFilter("hover-fills", false);
            popup.remove();
        });
        map.current.on('load', () => {
          map.current.setFilter("world_religion", f);
          map.current.setFilter("state-fills", f);
          map.current.setFilter("hover-fills", false);
          map.current.flyTo({
            center: [80, 30],
            zoom: 2.5,
          });
          
          SideController(map);
          document.getElementById("rotationRE").onclick= resetRfun;
          document.getElementById("tiltRE").onclick= resetTfun;
          document.getElementById("rotationsliderinput").oninput= barRotate;
          document.getElementById("tiltsliderinput").oninput= barTilt;
          
          document.getElementsByClassName("save")[0].onclick = function(){
            setSideMode("save")
          }
          
        })

        map.current.on('zoom', () => {
          var zlevel = parseInt(map.current.getZoom());
          document.getElementById('zoomextent').innerHTML=zlevel;
          });

        map.current.on('rotate', function () {
          document.getElementById('rotationslidercurrent').innerHTML='Rotate: ' + map.current.getBearing().toFixed(1) + '&#xb0;'
          document.getElementById('rotationsliderinput').value = map.current.getBearing();
          document.getElementById('rotationslider').style.display = 'unset';
        });

        map.current.on('pitch', function () {
          document.getElementById('tiltslidercurrent').innerHTML='Tilt: ' + map.current.getPitch().toFixed(1) + '&#xb0;'
          document.getElementById('tiltsliderinput').value = map.current.getPitch();
          document.getElementById('tiltslider').style.display = 'unset';
          // document.getElementById('rotationsliderinput').getAttribute("value").value(map.current.getBearing().toFixed(1))
        });

        map.current.on('moveend', () => {
          setSideFeatures(religious_data.filter(feature=>subs.includes(feature.HighRelig)));
          c="";
        });

        map.current.on('load', () => {
        //   map.current.loadImage(otherSub, function (error0, image0) {
        //     if (error0) throw error0;
        //     map.current.addImage("otherSub", image0, {});
        //     map.current.addLayer({
        //         "id": "otherSub1",
        //         "type": "fill",
        //         "source": "world_religion",
        //         'maxzoom': 6,
        //         'minzoom': 1,
        //         'filter': ["all", ["==",'HighRelig', 'East Asian Religiosity'],['==', 'SecRelig', 'Ethnic and other religionists']],
        //         'paint': {'fill-pattern': 'otherSub','fill-opacity': 1,},
        //         'source-layer': 'BRI_Religion_JSON2',
        //     }, 'hover-fills');
        //     map.current.addLayer({
        //       "id": "otherSub2",
        //       "type": "fill",
        //       "source": "world_religion",
        //       'maxzoom': 6,
        //       'minzoom': 1,
        //       'filter': ["all",['==', 'HighRelig', 'Buddhists(Theravada)'],['==', 'SecRelig', 'Ethnic and other religionists']],
        //       'paint': {'fill-pattern': 'otherSub','fill-opacity': 1,},
        //       'source-layer': 'BRI_Religion_JSON2',
        //   }, 'hover-fills');
        //   map.current.addLayer({
        //     "id": "otherSub3",
        //     "type": "fill",
        //     "source": "world_religion",
        //     'maxzoom': 6,
        //     'minzoom': 1,
        //     'filter': ["all",['==', 'HighRelig', 'Buddhists(Tibetan Buddhism)'],['==', 'SecRelig', 'Ethnic and other religionists']],
        //     'paint': {'fill-pattern': 'otherSub','fill-opacity': 1,},
        //     'source-layer': 'BRI_Religion_JSON2',
        // }, 'hover-fills');
        //   });
          map.current.loadImage(tibetanSub, function (error0, image0) {
            if (error0) throw error0;
            map.current.addImage("tibetanSub", image0, {});
            map.current.addLayer({
                "id": "tibetanSub",
                "type": "fill",
                "source": "world_religion",
                'maxzoom': 6,
                'minzoom': 1,
                'filter': ["all",['==', 'SecRelig', 'Buddhists(Tibetan Buddhism)']],
                'paint': {'fill-pattern': 'tibetanSub','fill-opacity': 1,},
                'source-layer': 'BRI_Religion_JSON2',
            }, 'hover-fills');
          });
          map.current.loadImage(theravadaSub, function (error0, image0) {
            if (error0) throw error0;
            map.current.addImage("theravadaSub", image0, {});
            map.current.addLayer({
                "id": "theravadaSub",
                "type": "fill",
                "source": "world_religion",
                'maxzoom': 6,
                'minzoom': 1,
                'filter': ["all",['==', 'SecRelig', 'Buddhists(Theravada)']],
                'paint': {'fill-pattern': 'theravadaSub','fill-opacity': 1,},
                'source-layer': 'BRI_Religion_JSON2',
            }, 'hover-fills');
          });
          map.current.loadImage(eastSub, function (error0, image0) {
            if (error0) throw error0;
            map.current.addImage("eastSub", image0, {});
            map.current.addLayer({
                "id": "eastSub",
                "type": "fill",
                "source": "world_religion",
                'maxzoom': 6,
                'minzoom': 1,
                'filter': ["all",['==', 'SecRelig', 'East Asian Religiosity']],
                'paint': {'fill-pattern': 'eastSub','fill-opacity': 1,},
                'source-layer': 'BRI_Religion_JSON2',
            }, 'hover-fills');
          });
          map.current.loadImage(mahayanaSub, function (error0, image0) {
            if (error0) throw error0;
            map.current.addImage("mahayanaSub", image0, {});
            map.current.addLayer({
                "id": "mahayanaSub",
                "type": "fill",
                "source": "world_religion",
                'maxzoom': 6,
                'minzoom': 1,
                'filter': ["all",['==', 'SecRelig', 'Buddhists(Mahayana)']],
                'paint': {'fill-pattern': 'mahayanaSub','fill-opacity': 1,},
                'source-layer': 'BRI_Religion_JSON2',
            }, 'hover-fills');
          });
          // map.current.loadImage(sunniSub, function (error0, image0) {
          //   if (error0) throw error0;
          //   map.current.addImage("sunniSub", image0, {});
          //   map.current.addLayer({
          //       "id": "sunniSub",
          //       "type": "fill",
          //       "source": "world_religion",
          //       'maxzoom': 6,
          //       'minzoom': 1,
          //       'filter': ["all",['==', 'HighRelig', 'East Asian Religiosity'],['==', 'SecRelig', 'Muslims(Sunni)']],
          //       'paint': {'fill-pattern': 'sunniSub','fill-opacity': 1,},
          //       'source-layer': 'BRI_Religion_JSON2',
          //   }, 'hover-fills');
          // });
        });
       
    }, []);

    const [subs,setSubs] = useState(["Buddhists(Tibetan Buddhism)","Buddhists(Theravada)","Buddhists(Mahayana)", "East Asian Religiosity"]);
    const [f,setF] = useState([
      "any",
      ["==", "HighRelig", "Buddhists(Tibetan Buddhism)"],
      ["==", "HighRelig", "Buddhists(Theravada)"],
      ["==", "HighRelig", "Buddhists(Mahayana)"],
      ["==", "HighRelig", "East Asian Religiosity"],
      ["==", "SecRelig", "Buddhists(Tibetan Buddhism)"],
      ["==", "SecRelig", "Buddhists(Theravada)"],
      ["==", "SecRelig", "Buddhists(Mahayana)"],
      ["==", "SecRelig", "East Asian Religiosity"],
    ]);
    
    function chartMouseOver(feature){
      setFirstReligion(feature.HighRelig);
      setSecondReligion(feature.SecRelig);
      setProvince(feature.ProvName);
      setCountry(feature.Country);
      setNumerical(feature.Numerical);
      setYear(feature.Year);
      setDataSource(feature.DataSource);
      setDataURL(feature.DataURL);
      map.current.setFilter("hover-fills", ["all",["==", "Country", feature.Country],["==", "ProvName", feature.ProvName],]);
    }

    function chartClick(feature){
      var a = Centroid.find(e=>e.ProvName==feature.ProvName);
      map.current.flyTo({
        center: [a.X, a.Y],
        zoom: a.zoomlevel}
      );
      map.current.setFilter("hover-fills", ["all",["==", "Country", feature.Country],["==", "ProvName", feature.ProvName],]);
    }

    function save(country, province){
      var a = religious_data.find(e=>(e.ProvName==province && e.Country==country));
      var s = saved;
      if (!s.includes(a)){
        s.push(a);
        var a = Centroid.find(item=>item.ProvName==province);console.log([a.X,a.Y]);
          const marker = new mapboxgl.Marker();
          marker.setLngLat([a.X,a.Y]).addTo(map.current);
          markers[province] = marker;
      }
      else{
        var index = s.indexOf(a);
        if (index !== -1) {s.splice(index, 1);}
        console.log(markers)
        markers[province].remove();
        delete markers[province];
      }
                                      
      
      setSaved(s);
    }

    function resetRfun() {map.current.rotateTo(0)}
    function resetTfun(){map.current.setPitch(0)}
    function barRotate(){var v = document.getElementById('rotationsliderinput').value;map.current.rotateTo(v);}
    function barTilt(){var v = document.getElementById('tiltsliderinput').value;map.current.setPitch(v);}

    const [tibetanOn,setTibetanOn] = useState(true);
    const [theravadaOn,setTheravadaOn] = useState(true);
    const [mahayanaOn,setMahayanaOn] = useState(true);
    const [eastOn, setEastOn] = useState(true);

    function toggleSubreligion(religion){
      var a;
      var temp = subs;

        if(religion=="Buddhists(Tibetan Buddhism)"){a=tibetanOn;}
        if(religion=="Buddhists(Theravada)"){a=theravadaOn;}
        if(religion=="Buddhists(Mahayana)"){a=mahayanaOn;}
        if(religion=="East Asian Religiosity"){a=eastOn;}
        if(a){
          // if(religion=="Buddhists(Tibetan Buddhism)"){
          //   map.current.setFilter("tibetanSub", false);
          // }
          // if(religion=="Buddhists(Theravada)"){
          //   map.current.setFilter("theravadaSub", false);
          // }
          // if(religion=="Buddhists(Mahayana)"){
          //   map.current.setFilter("mahayanaSub", false);
          // }
          // if(religion=="East Asian Religiosity"){
          //   map.current.setFilter("eastSub", false);
          // }
          var f2 = f.filter(e => e[2] !== religion)
          map.current.setFilter("world_religion", f2);
          setF(f2);
          var index = temp.indexOf(religion);
          temp.splice(index, 1);
          sideFilter(temp);
          setSubs(temp);
        }
        else{
          // if(religion=="Buddhists(Tibetan Buddhism)"){
          //   map.current.setFilter("tibetanSub", ["all",['==', 'SecRelig', 'Buddhists(Tibetan Buddhism)']]);
          // }
          // if(religion=="Buddhists(Theravada)"){
          //   map.current.setFilter("theravadaSub", ["all",['==', 'SecRelig', 'Buddhists(Theravada)']]);
          // }
          // if(religion=="Buddhists(Mahayana)"){
          //   map.current.setFilter("mahayanaSub", ["all",['==', 'SecRelig', 'Buddhists(Mahayana)']]);
          // }
          // if(religion=="East Asian Religiosity"){
          //   map.current.setFilter("eastSub", ["all",['==', 'SecRelig', 'East Asian Religiosity']]);
          // }
          var b = ["==", "HighRelig"];
          b.push(religion);
          var f3 = f.concat([b]);
          map.current.setFilter("world_religion", f3);
          setF(f3);
          temp.push(religion);
          console.log(temp);
          sideFilter(temp);
          setSubs(temp);
        }
    }

    function sideFilter(subs){
      const features = religious_data.filter(feature=>subs.includes(feature.HighRelig));
      setSideFeatures(features);c="";
    }

    const [cityOn, setCityOn] = useState(true);
    const [stateOn, setStateOn] = useState(true);
    const [countryBOn, setCountryBOn] = useState(true);
    const [provinceBOn, setProvinceBOn] = useState(true);
    function toggleCity(){
      if(cityOn){map.current.setLayoutProperty("settlement-label", 'visibility', 'none');}
      else{map.current.setLayoutProperty("settlement-label", 'visibility', 'visible');}
      setCityOn(!cityOn);
    }
    function toggleState(){
      if(stateOn){map.current.setLayoutProperty("state-label", 'visibility', 'none');}
      else{map.current.setLayoutProperty("state-label", 'visibility', 'visible');}
      setStateOn(!stateOn);
    }
    function toggleCountryB(){
      if(countryBOn){map.current.setLayoutProperty("admin-0-boundary", 'visibility', 'none');map.current.setLayoutProperty("admin-0-boundary-bg", 'visibility', 'none');}
      else{map.current.setLayoutProperty("admin-0-boundary", 'visibility', 'visible');map.current.setLayoutProperty("admin-0-boundary-bg", 'visibility', 'visible');}
      setCountryBOn(!countryBOn);
    }
    function toggleProvinceB(){
      if(provinceBOn){map.current.setLayoutProperty("admin-1-boundary", 'visibility', 'none');map.current.setLayoutProperty("admin-1-boundary-bg", 'visibility', 'none');map.current.setLayoutProperty("state-label", 'visibility', 'none');}
      else{map.current.setLayoutProperty("admin-1-boundary", 'visibility', 'visible');map.current.setLayoutProperty("admin-1-boundary-bg", 'visibility', 'visible');}
      setProvinceBOn(!provinceBOn);
    }
    
    const [sideMode, setSideMode] = useState("intro");
    const [asc, setAsc] = useState("ascending");

    function ascend(x,y){return ((x.Numerical==y.Numerical)?0:((x.Numerical>y.Numerical)?1:-1));}
    function descend(x,y){return ((x.Numerical==y.Numerical)?0:((x.Numerical<y.Numerical)?1:-1));}
    function byCountry(x,y){return ((x.Country==y.Country)?0:((x.Country>y.Country)?1:-1));}

    const [saved, setSaved] = useState([]);

    const [subDomOn, setSubDomOn] = useState(true);
    function toggleSubdominant(){
        if(subDomOn){
          map.current.setFilter("tibetanSub", false);
          map.current.setFilter("theravadaSub", false);
          map.current.setFilter("mahayanaSub", false);
          map.current.setFilter("eastSub", false);
        }
        else{
          map.current.setFilter("tibetanSub", ["all",['==', 'SecRelig', 'Buddhists(Tibetan Buddhism)']]);
          map.current.setFilter("theravadaSub", ["all",['==', 'SecRelig', 'Buddhists(Theravada)']]);
          map.current.setFilter("mahayanaSub", ["all",['==', 'SecRelig', 'Buddhists(Mahayana)']]);
          map.current.setFilter("eastSub", ["all",['==', 'SecRelig', 'East Asian Religiosity']]);
        }
        setSubDomOn(!subDomOn)
    }




    return (
        <div className="homeMap">
            <Link to="/" style={{textDecoration:"none", position:"absolute", top:"0",left:"10px", color:"#DDDDDD"}}>
                <div className="backButton"> <AiFillCaretLeft size={28}/>Full Map Mode</div>
            </Link>
            <div className="religionPageList">
                <div style={{width:"33vw"}}>
                  <div style={{backgroundColor:"#FEB32A"}}>The Buddhist World</div>
                </div>
                <div onClick={()=>{toggleSubreligion("Buddhists(Tibetan Buddhism)");setTibetanOn(!tibetanOn);}}
                style={tibetanOn?{background:"transparent linear-gradient(270deg, #FFFFDB 0%, #FDFD9E 40%, #FCFD4A 60%, #CACA2A 99%, #CACA2A 100%) 0% 0%",width:"16.75vw"}:{background:"lightgrey",width:"16.75vw"}}>
                  Tibetan
                </div>
                <div onClick={()=>{toggleSubreligion("Buddhists(Theravada)");setTheravadaOn(!theravadaOn);}} 
                style={theravadaOn?{background:"transparent linear-gradient(270deg, #FFF4DC 0%, #FCD77E 40%, #FDB434 60%, #E49A25 100%) 0% 0%", width:"16.75vw"}:{background:"lightgrey", width:"16.75vw"}}>
                  Theravada
                </div>
                <div onClick={()=>{toggleSubreligion("Buddhists(Mahayana)");setMahayanaOn(!mahayanaOn);}} 
                style={mahayanaOn?{background:"transparent linear-gradient(270deg, #EEFFCC 0%, #DEFF9E 40%, #DAFF91 60%, #AAFF00 100%) 0% 0%", width:"16.75vw"}:{background:"lightgrey", width:"16.75vw"}}>
                  Mahayana
                </div>
                <div onClick={()=>{toggleSubreligion("East Asian Religiosity");setEastOn(!eastOn);}} 
                style={eastOn?{background:"transparent linear-gradient(270deg, #FDC2B4 0%, #FD7454 40%, #FD3D20 60%, #CA3017 100%) 0% 0%", width:"16.75vw"}:{background:"lightgrey", width:"16.75vw"}}>
                  East Asian
                </div>
            </div>
            <div className="religionMapMain">
                <div className="religionPageSide">
                  {sideMode=="save"&&
                  <>
                  <div><button onClick={()=>setSideMode("by country")}>back</button></div>

                    {saved.map(feature=>
                                  <>
                                    <div className="sideBlock" onMouseOver={() => chartMouseOver(feature)}
                                        onMouseLeave={() => {map.current.setFilter("hover-fills", false);}}
                                        onClick={()=>chartClick(feature)}>
                                      {feature.Country} - {feature.ProvName}<br/>
                                      
                                    
                                    <button onClick = {()=>{
                                      markers[feature.ProvName].remove();
                                      delete markers[feature.ProvName];

                                      var a = religious_data.find(e=>(e.ProvName==feature.ProvName && e.Country==feature.Country));
                                      var s = saved;
                                      var index = s.indexOf(a);
                                      if (index !== -1) {s.splice(index, 1);}
                                      setSaved(s);
                                      }}>
                                      X
                                    </button> 
                                    </div>
                                    <PercentageBar percent1={feature.Numerical} religion1={feature.HighRelig}
                                    percent2={feature.Nummeric_1} religion2={feature.SecRelig}/>
                                    Year: {feature.Year}<br/>
                                    <a href={feature.DataURL}>{feature.DataSource}</a>
                                  </>)}
                    {saved.length==0&&"No Saved Results"}
                  </>
                  }
                  {sideMode!="save"&&<>
                    <div className="religionPageSideButtons" style={{display:"flex", backgroundColor:"#CECECE", position:"sticky", height:"5%"}}>
                      <button style={sideMode=="intro"?{backgroundColor:"grey"}:{backgroundColor:"white"}} onClick={()=>setSideMode("intro")}>intro</button>
                      <button style={sideMode=="by country"?{backgroundColor:"grey"}:{backgroundColor:"white"}} onClick={()=>setSideMode("by country")}>by country</button>
                      {sideMode=="by country"&&(<>
                        <button onClick={()=>setAsc("ascending")} style={asc=="ascending"?{backgroundColor:"grey"}:{backgroundColor:"white"}}>ascending</button>
                        <button onClick={()=>setAsc("descending")} style={asc=="descending"?{backgroundColor:"grey"}:{backgroundColor:"white"}}>descending</button>
                      </>)}
                      
                    </div>
                    
                    {sideMode=="intro"&&<ReligionPageSide religion="Buddhism" country={country} province={province} firstReligion={firstReligion} numerical={numerical} secondReligion={secondReligion}
                    numeric_1={numeric_1} year={year} dataSource={dataSource} dataURL={dataURL}/>}
                    {sideMode=="by country"&&
                    <>
                      <div className="sideContent">
                      {sideFeatures.sort(byCountry).map(
                        function(feature) {
                          if(c=="" || c!=feature.Country){
                            c = feature.Country;
                            return(
                            <Collapsible trigger={<><AiFillCaretRight/>{c}</>} triggerWhenOpen={<><AiFillCaretDown/>{c}</>}>
                              {asc=="ascending"&&
                                sideFeatures.filter(feature=>feature.Country==c).sort(ascend).map(feature=>
                                  <>
                                    <div className="sideBlock" onMouseOver={() => chartMouseOver(feature)}
                                        onMouseLeave={() => {map.current.setFilter("hover-fills", false);}}
                                        onClick = {() => {chartClick(feature);setSideMode(feature.Country.toString());}}
                                          >
                                      {feature.ProvName}
                                    </div> 
                                    <PercentageBar percent1={feature.Numerical} religion1={feature.HighRelig}
                                    percent2={feature.Nummeric_1} religion2={feature.SecRelig}/>
                                  </>
                                )
                              }
                              {asc=="descending"&&
                                sideFeatures.filter(feature=>feature.Country==c).sort(descend).map(feature=>
                                  <>
                                    <div className="sideBlock" onMouseOver={() => chartMouseOver(feature)}
                                        onMouseLeave={() => {map.current.setFilter("hover-fills", false);}}
                                        onClick = {() => {chartClick(feature);setSideMode(feature.Country.toString());}}
                                          >
                                      {feature.ProvName}
                                    </div> 
                                    <PercentageBar percent1={feature.Numerical} religion1={feature.HighRelig}
                                    percent2={feature.Nummeric_1} religion2={feature.SecRelig}/>
                                  </>
                                )
                              }
                            </Collapsible>
                            )                          
                          }  
                        }
                      )}
                      </div>
                      <div className="note" style={{height:"30%", fontSize:"xsmall", backgroundColor:"lightgrey"}}>
                        Note<br/>
                        Province:{province}<br/>
                        Dominant Religion:{firstReligion}<br/>
                        Data Source:<br/><a target="_blank_" href={dataURL}>{dataSource}</a>
                      </div>
                    </>
                    }
                    {sideMode!="by country"&&sideMode!="intro"&&sideMode!="saved"&&
                    <>
                        <div><button onClick={()=>setSideMode("by country")}>back</button>{sideMode}</div>
                        <div className="sideContent">{
                          sideFeatures.filter(feature=>feature.Country==sideMode).sort(ascend).map(feature=>
                            <>
                              <div id={feature.ProvName} className="sideBlock" onMouseOver={() => chartMouseOver(feature)}
                                  onMouseLeave={() => {map.current.setFilter("hover-fills", false);}}
                                  onClick = {() => chartClick(feature)}
                                    >
                                {feature.ProvName}
                              </div> 
                              <PercentageBar percent1={feature.Numerical} religion1={feature.HighRelig}
                              percent2={feature.Nummeric_1} religion2={feature.SecRelig}/>
                            </>
                          )}
                        </div>
                        <div className="note" style={{height:"30%", fontSize:"xsmall", backgroundColor:"lightgrey"}}>
                        Note<br/>
                        Province:{province}<br/>
                        Dominant Religion:{firstReligion}<br/>
                        Data Source:<br/><a target="_blank_" href={dataURL}>{dataSource}</a>
                        </div>
                    </>
                    }
                  </>}
                </div>
                <div className = "search">
                  {/* <ReactSearchAutocomplete
                    items={religious_data.filter(e=>subs.includes(e.HighRelig))}
                    onSearch={handleOnSearch}
                    onHover={handleOnHover}
                    onSelect={handleOnSelect}
                    onFocus={handleOnFocus}
                    placeholder="Search"
                    autoFocus
                    formatResult={formatResult}
                    fuseOptions={{ keys: ["Country","Provname"] }}
                    resultStringKeyName="Country"
                    maxResults={100}
                  /> */}
                  <select id = "projection" onChange={()=>{map.current.setProjection(document.getElementById("projection").value);}}>
                      <option value="mercator">Mercator</option>
                      <option value="winkelTripel">Winkel Tripel</option>
                      <option value="naturalEarth">Natural Earth</option>
                  </select>
                  <button onClick = {()=>toggleSubdominant()}>SubReligion</button>
                </div>
                <div ref={mapContainer} className="religion-map-container" />
                
                
            </div>
            
            <div className="bottomBar">
              <AiFillCaretRight style={{verticalAlign:"bottom"}}/>Customization of the map view
              <button onClick={()=>toggleCity()}>City</button>
              <button onClick={()=>toggleState()}>State</button>
              <button onClick={()=>toggleCountryB()}>CountryB</button>
              <button onClick={()=>toggleProvinceB()}>ProvinceB</button>
            </div>
        </div>
    );
};

export default BuddhismPage;